import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const CameraIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" className={className} onClick={onClick}>
      <path d="M467 121h-86.703L369.12 65.117C366.326 51.143 353.954 41 339.703 41H172.297c-14.25 0-26.623 10.143-29.417 24.117L131.703 121H45c-24.813 0-45 20.187-45 45v260c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45V166c0-24.813-20.187-45-45-45zM172.297 71h167.406l10 50H162.297zM482 426c0 8.271-6.729 15-15 15H45c-8.271 0-15-6.729-15-15V166c0-8.271 6.729-15 15-15h422c8.271 0 15 6.729 15 15z"></path>
      <path d="M256 185c-61.206 0-111 49.794-111 111s49.794 111 111 111 111-49.794 111-111-49.794-111-111-111zm0 192c-44.664 0-81-36.337-81-81s36.336-81 81-81 81 36.337 81 81-36.336 81-81 81zM128 185H80c-8.284 0-15 6.716-15 15s6.716 15 15 15h48c8.284 0 15-6.716 15-15s-6.716-15-15-15z"></path>
    </svg>
  );
};

export default CameraIcon;
